module.exports = __webpack_public_path__ + "static/media/Adi.bdde0241.png";